import React from 'react';
import { Button } from '../ui/Button';

type SignupStepActionsProps = {
  primaryLabel: string;
  onPrimaryClick: () => void;
  onBack?: () => void;
  primaryDisabled?: boolean;
  primaryLoading?: boolean;
  backDisabled?: boolean;
};

export const SignupStepActions: React.FC<SignupStepActionsProps> = ({
  primaryLabel,
  onPrimaryClick,
  onBack,
  primaryDisabled = false,
  primaryLoading = false,
  backDisabled = false,
}) => {
  return (
    <div className="self-stretch flex flex-col justify-center items-center gap-1 py-0.5 mt-1.5">
      <Button onClick={onPrimaryClick} disabled={primaryDisabled} loading={primaryLoading}>
        {primaryLabel}
      </Button>
      {onBack && (
        <Button variant="ghost" onClick={onBack} disabled={backDisabled}>
          ← Back
        </Button>
      )}
    </div>
  );
};
